import {VarietyModel} from '../../model/md/VarietyModel.js';
import {BaseCollection} from '../BaseCollection';

/**
 * @class VarietyCollection
 * @extends BaseCollection
 */
export class VarietyCollection extends BaseCollection {

    initialize (models, options) {

        super.initialize(models, options);

        this.microservice = 'md2';
        this.resource = 'varieties';
    }

    get model () {

        return VarietyModel;
    }

    static get REGISTRATION_STATUSES () {

        return {
            REGISTERED: {
                name: 'Registered',
                uuid: '241d4e31-385f-f739-8d46-28e3458b0aac'
            }
        };
    }
}


// WEBPACK FOOTER //
// ./shared/collection/md/VarietyCollection.js